/**
 * A one-time code an instance issued for an assistant, plus the host that
 * issued it. The CLI exchanges the code against that same host, so both travel
 * together and the user never has to say which region or instance they use.
 */
export class AssistantAuthorization {
  readonly code: string;
  readonly instance: string;
  readonly expiresInMinutes: number;

  constructor({ code, instance, expiresInMinutes }: AssistantAuthorizationData) {
    this.code = code;
    this.instance = instance;
    this.expiresInMinutes = expiresInMinutes;
  }

  /** What the user pastes into the assistant when it cannot listen locally. */
  get pasteCode(): string {
    return `${this.instance}/${this.code}`;
  }
}

export interface AssistantAuthorizationData {
  code: string;
  instance: string;
  expiresInMinutes: number;
}
